<!-- Copyright (c) 2021-2024 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details. -->
<script>
import {
  translationExists,
  toTranslationKey,
  getLocalizedString,
  isTranslationKey,
  getTranslation,
} from '@forgerock/platform-shared/src/utils/translations';

export default {
  name: 'TranslationMixin',
  methods: {
    translationExists,
    toTranslationKey,
    getLocalizedString,
    isTranslationKey,
    getTranslation,
    /**
     * Returns the display name for the current resource type in the current locale.
     * Use for messages like deleteSuccess/deleteObject so "{object}" or "{resource}" is translated.
     * Requires component to have resourceName and optionally resourceTitle in data.
     */
    getTranslatedResourceName() {
      if (!this.resourceName) return '';
      const pageTitlesKey = `resources.${this.resourceName}`;
      const fromPageTitles = this.$t(pageTitlesKey);
      if (fromPageTitles !== pageTitlesKey) {
        return fromPageTitles;
      }
      if (this.resourceTitle) {
        const fromSchema = this.getTranslation(this.resourceTitle);
        if (fromSchema && fromSchema !== this.resourceTitle) {
          return fromSchema;
        }
      }
      return this.resourceName;
    },
  },
};
</script>
